import { render } from "./Modal.vue?vue&type=template&id=2345a67a&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=2345a67a&lang=scss&scoped=true"
import "./Modal.vue?vue&type=style&index=1&id=2345a67a&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2345a67a"]])

export default __exports__